
import { createApi } from "@reduxjs/toolkit/query/react";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";


const commonServiceApi = createApi({
    reducerPath: 'commonServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getAllDropDownsForMember: builder.query({
            query: () => ({
                url: encryptQueryString('/Membership/GetAllDropDownsForMembership'),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        storeBase64Image: builder.mutation({
            query: (details) => ({
                url: '/Common/StoreBase64Image',
                method: 'POST',
                body: details,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        uploadPDF: builder.mutation({
            query: (details) => ({
                url: '/Common/UploadPDF',
                method: 'POST',
                body: details,
                formData: true
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getPDF: builder.query({
            query: (details) => ({
                url: `/Common/getPDF?fileName=${details.fileName}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        
    }),
})

export const {
    useLazyGetAllDropDownsForMemberQuery,
    useStoreBase64ImageMutation,
    useUploadPDFMutation,
    useLazyGetPDFQuery,
   
} = commonServiceApi;

export default commonServiceApi;





